const encrypted = process.env.VUE_APP_ENCRYPTED === "true";
const REST_ENDPOINT =
  "http" + (encrypted ? "s" : "") + "://" + process.env.VUE_APP_BACKEND_API_URL;

export const restEndpoint = (path: string) => REST_ENDPOINT + path;

export const WS_ENDPOINT =
  "ws" + (encrypted ? "s" : "") + "://" + process.env.VUE_APP_BACKEND_WS_URL;

export const youtubeBroadcastUrl = () => `${REST_ENDPOINT}/dar/youtube/broadcast`;

export const youtubeAuthUrl = () => `${REST_ENDPOINT}/dar/youtube/callback`;
